<template>
  <el-select
    class="TicketWorkflowSelect"
    disabled
    @change="onChange"
    :value="valueData"
    clearable
    placeholder="工单关联流程"
    style="width:100%;">
    <el-option v-for="e in ticketWorkflowList"
      :key="e.id"
      :label="e.name"
      :value="e.id" />
  </el-select>
</template>

<script>
export default {
  name: "TicketWorkflowSelect",

  props : ["value"],

  data() {
      return {
        valueData : null,
        ticketWorkflowList : []
      };
  },

  watch : {
    value() {
      this.load0();
    }
  },

  mounted: function() {
    this.load0();
  },

  methods: {
    load0() {
      var _this = this;
      sdk.TicketWorkflowApi().listMyWorkflowCached({
        page : { pageSize : 9999, orderBy : '`index` DESC' }
      }).then(res => {
        _this.ticketWorkflowList = res.list;

        _this.valueData = _this.value;
      });
    },

    onChange(value) {
      this.valueData = value;
      this.$emit('change', value);
      this.$emit('input', value);
    }
  }
}
</script>

<style>
.TicketWorkflowSelect .el-input.is-disabled .el-input__inner {
  background-color : unset;
}
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketWorkflowSelect.vue